var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChrome = function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 17.25a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#229342",
    d: "M7.453 14.626 2.907 6.752A10.498 10.498 0 0 0 12.001 22.5l4.546-7.874v-.001a5.249 5.249 0 0 1-9.094.001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC116",
    d: "M16.547 14.626 12 22.5a10.498 10.498 0 0 0 9.091-15.75H12a5.25 5.25 0 0 1 4.548 7.876"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A73E8",
    d: "M12 16.157a4.156 4.156 0 1 0 0-8.313 4.156 4.156 0 0 0 0 8.313"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E33B2E",
    d: "M12 6.75h9.092a10.498 10.498 0 0 0-18.185.002l4.546 7.874h.002A5.25 5.25 0 0 1 12 6.75"
  })));
};
export default SvgChrome;